module.exports = __webpack_public_path__ + "static/media/9DESA10.7649aa5d.jpg";